import { createAsyncThunk } from "@reduxjs/toolkit";
import { OnboardingRulesProgressResponse } from "@ifgengineering/client-invest-sdk";
import { logException } from "@helpers/logException/logException";
import { clientInvestSdk } from "@utils/clientInvestSdk";

const FETCH_DEAL_ANCHORED_PROGRESS_API = "FETCH_DEAL_ANCHORED_PROGRESS_API";

export const fetchDealAnchoredProgressAPI = createAsyncThunk<
  OnboardingRulesProgressResponse | null
>(FETCH_DEAL_ANCHORED_PROGRESS_API, async () => {
  try {
    const response = await clientInvestSdk.getOnboardingRulesProgress(
      "deal-anchored"
    );
    return response.data;
  } catch (e: unknown) {
    const status = (e as { response?: { status?: number } })?.response?.status;
    if (status !== 401) {
      logException({
        tag: "fetchDealAnchoredProgressAPI",
        exception: e,
      });
    }
    return null;
  }
});
